import { render, staticRenderFns } from "./standardList.vue?vue&type=template&id=3859e32c"
import script from "./standardList.vue?vue&type=script&lang=js"
export * from "./standardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports